module.exports = __webpack_public_path__ + "assets/images/invisible-asia/6-hongkong.jpg?v=f8436fb3";